import { URLSearch2Params, isEmpty, prefixUrl } from '@/common/utils/index'
import docCookie from '@extension/docCookie'
import qs from 'qs'

function getParams() {
  const search = URLSearch2Params()
  const tokenKeys = ['u', 'ti', 'tic', 'ticket', 't']
  const restParams = {}
  const tokenParams = {}
  Object.keys(search).forEach((key) => {
    if (tokenKeys.indexOf(key) >= 0) {
      tokenParams[key] = search[key]
    } else {
      restParams[key] = search[key]
    }
  })
  return { restParams, tokenParams }
}

export function initLogin() {
  const params = getParams()
  let { tokenParams = {}, restParams = {} } = params
  if (!isEmpty(tokenParams)) {
    const originParams = JSON.parse(docCookie.getItem('AUTH_PARAMS') || '{}')
    tokenParams = Object.assign({}, originParams, tokenParams)
    if (docCookie.setItem('AUTH_PARAMS', JSON.stringify(tokenParams))) {
      const { hash, pathname } = window.location
      return `${pathname}${
        isEmpty(restParams) ? '' : '?' + qs.stringify(restParams)
      }${hash}`
    }
    return ''
  }
  return ''
}

export function login(data) {
  docCookie.removeItem('AUTH_PARAMS')
  const { tokenParams } = getParams()
  docCookie.setItem('AUTH_PARAMS', JSON.stringify(tokenParams))
  window.location = data.redirectUrl
}

export function getAuthParams() {
  let params = JSON.parse(docCookie.getItem('AUTH_PARAMS') || '{}')
  if (isEmpty(params)) {
    params = getParams().tokenParams
  }
  return { ticket: params.ticket || '' }
  // return { ticket: '219eb329fb47486ca847609a1c77dac40002200386000' } // 分身ticket
  // return { ticket: '797e12f198bab38331fb1a3efa367fc10002200166000' }
}

export function logout() {
  window.location = prefixUrl('common.logout', {}, { isAddCommonParams: true })
}
